/**
 * this pipe use for converting text in upcoming event
 * change format date, next event tomorrow or today, and time formating
 */

import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'datePipe'
})
export class DatePipe implements PipeTransform {

  transform(value: any, type): any {
    switch (type) {
      case 'day': {
        return moment(value, 'DD-MM-YYYY').format('ddd, MMM DD');
      }
      case 'diff': {
        const diffDay = moment(value, 'DD-MM-YYYY').diff(moment().startOf('day'), 'days');
        let text = 'today';
        if (diffDay === 0) {
          text = 'today';
        } else if (diffDay === 1) {
          text = 'tomorrow';
        } else {
          text = `in ${diffDay} days`;
        }
        return text;
      }
      case 'time': {
        let num = value.match(/\d+/g);
        const text = value.match(/[a-zA-Z]+/g);
        num = num.map(val => parseInt(val, 10));
        let result = '';
        num.forEach((val, index) => {
          result += `${val} ${text[index]}`;
        });
        return result.replace('h', ' hour(s) ').replace('m', ' minute(s) ');
      }
    }
  }

}
